"use client";

import { Icon } from "@iconify/react";
import { useTranslate } from "@tolgee/react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem } from "@/components/ui";
import { useTheme } from "@/context/theme";
import { SELECTED_TOGGLE_SETTINGS, THEME_TOGGLE_OPTIONS } from "./constants";
import { ToggleDropdownTrigger } from "./ToggleDropdownTrigger";
import type { ToggleTriggerAs } from "./types";

export type ThemeToggleProps = {
  triggerAs?: ToggleTriggerAs;
};

export const ThemeToggle = ({ triggerAs = "navbar" }: ThemeToggleProps) => {
  const { t } = useTranslate();
  const { theme, setTheme, resolvedTheme } = useTheme();
  const triggerIcon = resolvedTheme === "dark" ? "lucide:moon" : "lucide:sun";
  const menuAlign = triggerAs === "sidebar-header" ? "start" : "end";

  return (
    <DropdownMenu>
      <ToggleDropdownTrigger
        triggerAs={triggerAs}
        ariaLabel={t("themeoption.toggle")}
        icon={triggerIcon}
      />
      <DropdownMenuContent align={menuAlign} className={SELECTED_TOGGLE_SETTINGS.dropdownClass}>
        {THEME_TOGGLE_OPTIONS.map((option) => (
          <DropdownMenuItem key={option.value} onClick={() => setTheme(option.value)}>
            <Icon icon={option.icon} />
            {t(option.labelKey)}
            {theme === option.value && (
              <Icon
                icon={SELECTED_TOGGLE_SETTINGS.icon}
                className={SELECTED_TOGGLE_SETTINGS.classes}
              />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
